"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.overrideMoment = overrideMoment;
exports.setMomentLocale = setMomentLocale;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function overrideMoment(momentInstance) {
  momentInstance.updateLocale('en-gb', {
    longDateFormat: {
      LT: 'hh:mm A',
      LTS: 'hh:mm:ss A',
      L: 'DD/MM/YYYY',
      LL: 'D MMMM YYYY',
      LLL: 'D MMMM YYYY hh:mm A',
      LLLL: 'dddd, D MMMM YYYY hh:mm A'
    }
  });
}

function setMomentLocale(_x, _x2) {
  return _setMomentLocale.apply(this, arguments);
}

function _setMomentLocale() {
  _setMomentLocale = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee(momentInstance, lang) {
    var dftLocale, lng, _lng$split, _lng$split2, shortLang, language;

    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            dftLocale = global && global.navigator && global.navigator.language || 'en';
            lng = lang || dftLocale;
            _lng$split = lng.split(/-/), _lng$split2 = (0, _slicedToArray2["default"])(_lng$split, 1), shortLang = _lng$split2[0];
            language = shortLang === 'en' ? 'en-gb' : shortLang;
            _context.next = 6;
            return Promise.resolve().then(function () {
              return _interopRequireWildcard(require("moment/locale/".concat(language)));
            });

          case 6:
            momentInstance.locale(language);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _setMomentLocale.apply(this, arguments);
}
//# sourceMappingURL=MomentUtils.js.map